import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'

export default {
  name: 'ChemicalEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      chemicalEditItem: null,
      convertUnitAcItem: '',
      convertUnitAcText: '',
      convertUnitAcKeepFirst: true,
      convertUnitAcOpenOnFocus: true,
      mode: 'edit'
    }
  },
  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.chemicalEditItem = {
        description: null,
        convertUnitId: '',
        cost: null,
        defaultApplicationRate: null
      }
    } else {
      this.mode = 'edit'
      const item = this.$store.getters.getChemicalItemById(this.id)
      // just want a local copy for the form
      this.chemicalEditItem = {...item}
    }
  },
  mounted () {
    // set the autocomplete for the convertUnit
    if (this.mode === 'edit') {
      const convertUnitAcItem = this.convertUnitsForAutocomplete.find((element) => {
        return element.value === this.chemicalEditItem.convertUnitId
      })
      this.$refs.convertUnitAutocomplete.setSelected(convertUnitAcItem)
    }
  },
  computed: {
    filteredConvertUnitAcItems () {
      return this.convertUnitsForAutocomplete.filter((option) => {
        return option.text
          .toString()
          .toLowerCase()
          .indexOf(this.convertUnitAcText.toLowerCase()) >= 0
      })
    },
    convertUnitsForAutocomplete () {
      return this.$store.getters.getConvertUnitsForAutocomplete
    }
  },
  methods: {
    convertUnitAcSelect (option) {
      if (option) {
        this.chemicalEditItem.convertUnitId = option.value
      }
      this.convertUnitAcItem = option
    },
    submitForm (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()
      jsConn.toRoutePath = '/chemicals'
      jsConn.formParams = {
        id: this.id,
        item: this.chemicalEditItem
      }

      this.$store.dispatch('updateChemicalItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push(jsConn.toRoutePath)
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
